// extracted by mini-css-extract-plugin
module.exports = {"container":"compact-disclaimer_container__ClXpX","darkThemed":"compact-disclaimer_darkThemed__tCT5_"};